module.exports = __webpack_public_path__ + "static/img/1-2.5baa8da9.png";